// bootstrap Components
import { Col, Card, Button } from "react-bootstrap";

// The Product component receives props from the App component then maps through items to return JSX
function Product(props) {
  return (
    <Col key={props.id}>
      <Card style={{ width: "18rem" }}>
        <Card.Img variant="top" src={props.image} />
        <Card.Body>
          <Card.Title>{props.name}</Card.Title>
          <Card.Text>{props.price}</Card.Text>
          <Card.Text>{props.description}</Card.Text>
          <Button variant="primary">ADD TO CART</Button>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default Product;
